import { AuditForm } from "./AuditForm";

export function CTA() {
  return (
    <section id="cta" className="py-24 px-6 bg-slate-950 border-t border-slate-800">
      <div className="max-w-3xl mx-auto text-center">
        <div className="p-8 sm:p-12 rounded-3xl bg-gradient-to-b from-slate-800/50 to-slate-900/50 border border-slate-700/50">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Voyons d'abord si votre site a un problème.
          </h2>
          <p className="text-slate-400 mb-8 max-w-xl mx-auto leading-relaxed">
            2 minutes pour soumettre votre URL. 2-3 minutes pour l'audit.
            Un rapport détaillé directement dans votre boîte mail. Aucune obligation derrière.
          </p>

          <AuditForm variant="card" id="audit-form-cta" source="landing-cta" />

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-x-6 gap-y-3 text-sm text-slate-500">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <code className="text-blue-300 font-mono text-xs bg-slate-800/60 px-1.5 py-0.5 rounded">
                audit@agents.levier-ia.fr
              </code>
            </span>
            <span className="hidden sm:block text-slate-700">|</span>
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Rapport en 2-3 minutes
            </span>
            <span className="hidden sm:block text-slate-700">|</span>
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Hébergé en France · RGPD
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
